module.exports = __webpack_public_path__ + "media/assets/faria_products/Atlas-d6beaf593c03e448168acb50d128c85757fa2625e374770d68140175987022ba.png";